import config from '../config';
import * as types from '../actions/types';
import * as request from '../utils/request';
import { getAssignment } from './studentsActionCreators';
import toastr from 'toastr';
import label from '../utils/lngEn';
import _ from 'underscore';

export function getConflictsSuccess(data) {
  return {
    type: types.GET_CONFLICTS_SUCCESS,
    payload: data
  };
}

export function getRequirementsSuccess(data) {
  return {
    type: types.GET_REQUIREMENTS_SUCCESS,
    payload: data
  };
}
export function getGroupConflictsSuccess(conflicts) {
  return {
    type: types.GET_ALL_GROUP_CONFLICTS_SUCCESS,
    payload: conflicts
  };
}
export function getGroupRequirementsSuccess(requirements) {
  return {
    type: types.GET_ALL_GROUP_REQUIREMENTS_SUCCESS,
    payload: requirements
  };
}

export function getStudentConflictsSuccess(conflicts) {
  return {
    type: types.GET_ALL_STUDENT_CONFLICTS_SUCCESS,
    payload: conflicts
  };
}
export function getStudentRequirementsSuccess(requirements) {
  return {
    type: types.GET_ALL_STUDENT_REQUIREMENTS_SUCCESS,
    payload: requirements
  };
}

export function getAllGroupLocksSuccess(locks) {
  return {
    type: types.GET_ALL_GROUP_LOCKS_SUCCESS,
    payload: locks
  };
}
export function getAllStudentLocksSuccess(locks) {
  return {
    type: types.GET_ALL_STUDENT_LOCKS_SUCCESS,
    payload: locks
  };
}

export function openRankingSession(runName, emailStudents) {
  return (dispatch) => {
    const promise = new Promise((resolve, reject) => {
      request
        .req('POST', '/runs/' + runName + '/start-elicitation/', {email_students: emailStudents})
        .then(() => {
          toastr.success('Starting ranking session.');
          return resolve();
        })
        .then(() => dispatch(getAssignment()))
        .catch(err => {
          toastr.error('There was a problem.');
          console.log('error', err.message);
          return reject();
        });
    });
    return promise;
  };
}

export function addNewRestriction(obj, type) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', '/runs/' + runName + '/' + type + '/', obj)
        .then(() => {
          toastr.success('Item Added Successfully.');
          return resolve();
        })
        .catch(err => {
          toastr.error('There was a problem.');
          console.log('error', err.message);
          return reject();
        });
    });
    return promise;
  };
}

export function putRestriction(obj, type) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('PUT', '/runs/' + runName + '/' + type + '/' + obj.id + '/', obj)
        .then(() => {
          toastr.success('Item Changed Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('error', err);
          toastr.error('There was some error editing ' + type + '.');
          return reject(err);
        });
    });
    return promise;
  };
}

export function getAllRestrictions(type) {
  let runName = localStorage.getItem('run');
  let array = [];
  console.log(type);

  return (dispatch) => {
    return new Promise((resolve, reject) => {
      function getRestrictions(url) {
        request
          .req('GET', url)
          .then(res => {
            res.data.results.forEach(req => {
              array.push(req);
            });
            if (res.data.next == null) {
              if (type == config.conflicts) {
                array = array.filter(conf => {
                  return !conf.is_time_conflict;
                });
                dispatch(getConflictsSuccess(array));
                return resolve();
              } else if (type == config.requirements) {
                dispatch(getRequirementsSuccess(array));
                return resolve();
              }
            } else {
              getRestrictions(res.data.next);
            }
          })
          .catch(err => {
            console.log('error', err);
            return reject();
          });
      }
      getRestrictions('/runs/' + runName + '/' + type + '/');
    });
  };
}

export function deleteRestiction(id, type) {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    request
      .req('DELETE', '/runs/' + runName + '/' + type + '/' + id + '/')
      .then(res => {
        if (res.status == 204) {
          let array = [];

          function getRestrictions(url) {
            request
              .req('GET', url)
              .then(res => {
                res.data.results.forEach(req => {
                  array.push(req);
                });
                if (res.data.next == null) {
                  if (type == config.conflicts) {
                    array = array.filter(conf => {
                      return !conf.is_time_conflict;
                    });
                    toastr.success(label.toastrDeleteSuccessful);
                    dispatch(getConflictsSuccess(array));
                  } else if (type == config.requirements) {
                    toastr.success(label.toastrDeleteSuccessful);
                    dispatch(getRequirementsSuccess(array));
                  }
                } else {
                  getRestrictions(res.data.next);
                }
              })
              .catch(err => {
                console.log('error', err);
              });
          }
          getRestrictions('/runs/' + runName + '/' + type + '/');
        }
      })
      .catch(err => {
        toastr.error(err.message);
      });
  };
}

// Group and Student restrictions
export function getAllGSRestrictions(gsId, type, typeR) {
  let runName = localStorage.getItem('run');
  let array = [];

  return (dispatch) => {
    return new Promise((resolve, reject) => {
      function getRestrictions(url) {
        request
          .req('GET', url)
          .then(res => {
            res.data.results.forEach(req => {
              array.push(req);
            });
            if (res.data.next == null) {
              if (typeR == config.conflicts) {
                array = array.filter(conf => {
                  return !conf.is_time_conflict;
                });
                if (type == config.groups) {
                  dispatch(getGroupConflictsSuccess(array));
                } else if (type == config.students) {
                  dispatch(getStudentConflictsSuccess(array));
                }
                return resolve();
              } else if (typeR == config.requirements) {
                if (type == config.groups) {
                  dispatch(getGroupRequirementsSuccess(array));
                } else if (type == config.students) {
                  dispatch(getStudentRequirementsSuccess(array));
                }
                return resolve();
              }
            } else {
              getRestrictions(res.data.next);
            }
          })
          .catch(err => {
            console.log('error', err);
            return reject();
          });
      }
      getRestrictions('/runs/' + runName + '/' + type + '/' + gsId + '/' + typeR + '/');
    });
  };
}

export function deleteGSRestiction(gsId, rId, type, typeR) {
  let runName = localStorage.getItem('run');
  return (dispatch) => {
    request
      .req('DELETE', '/runs/' + runName + '/' + type + '/' + gsId + '/' + typeR + '/' + rId + '/')
      .then(res => {
        if (res.status == 204) {
          let array = [];

          function getRestrictions(url) {
            request
              .req('GET', url)
              .then(res => {
                res.data.results.forEach(req => {
                  array.push(req);
                });
                if (res.data.next == null) {
                  if (typeR == config.conflicts) {
                    array = array.filter(conf => {
                      return !conf.is_time_conflict;
                    });
                    toastr.success(label.toastrDeleteSuccessful);
                    if (type == config.groups) {
                      dispatch(getGroupConflictsSuccess(array));
                    } else if (type == config.students) {
                      dispatch(getStudentConflictsSuccess(array));
                    }
                  } else if (typeR == config.requirements) {
                    toastr.success(label.toastrDeleteSuccessful);
                    if (type == config.groups) {
                      dispatch(getGroupRequirementsSuccess(array));
                    } else if (type == config.students) {
                      dispatch(getStudentRequirementsSuccess(array));
                    }
                  }
                } else {
                  getRestrictions(res.data.next);
                }
              })
              .catch(err => {
                console.log('error', err);
              });
          }
          getRestrictions('/runs/' + runName + '/' + type + '/' + gsId + '/' + typeR + '/');
        }
      })
      .catch(err => {
        toastr.error(err.message);
      });
  };
}

export function putGSRestriction(gsId, obj, type, typeR) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('PUT', '/runs/' + runName + '/' + type + '/' + gsId + '/' + typeR + '/' + obj.id + '/', obj)
        .then(() => {
          toastr.success('Item Changed Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('error', err);
          toastr.error('There was some error editing ' + type + '.');
          return reject(err);
        });
    });
    return promise;
  };
}

export function addNewGSRestriction(gsId, obj, type, typeR) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('POST', '/runs/' + runName + '/' + type + '/' + gsId + '/' + typeR + '/', obj)
        .then(() => {
          toastr.success('Item Added Successfully.');
          return resolve();
        })
        .catch(err => {
          toastr.error('There was a problem.');
          console.log('error', err.message);
          return reject();
        });
    });
    return promise;
  };
}

export function getAllLocks(gsId, type) {
  let runName = localStorage.getItem('run');
  let locks = [];
  return (dispatch) => {
    let promise = new Promise((resolve, reject) => {
      function getLocks(url) {
        request
          .req('GET', url)
          .then(res => {
            res.data.results.forEach(lock => {
              locks.push(lock);
            });
            if (res.data.next == null) {
              type == config.groups
                ? dispatch(getAllGroupLocksSuccess(locks))
                : dispatch(getAllStudentLocksSuccess(locks));
              return resolve();
            } else {
              getLocks(res.data.next);
            }
          })
          .catch(err => {
            console.log('err', err);
            return reject();
          });
      }
      getLocks('/runs/' + runName + '/' + type + '/' + gsId + '/locks/');
    });
    return promise;
  };
}

export function deleteLock(groupId, id, type) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      request
        .req('DELETE', '/runs/' + runName + '/' + type + '/' + groupId + '/locks/' + id + '/')
        .then(() => {
          toastr.success('Item Deleted Successfully.');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('There was some error.');
          return reject();
        });
    });
    return promise;
  };
}

export function AddLocks(gsId, coursesArray, type) {
  let runName = localStorage.getItem('run');
  return () => {
    let promise = new Promise((resolve, reject) => {
      let promises = coursesArray.map(course => {
        let obj = {
          course: course.id
        };
        return request.req('POST', '/runs/' + runName + '/' + type + '/' + gsId + '/locks/', obj);
      });
      Promise.all(promises)
        .then(() => {
          toastr.success('Lock(s) created successfully');
          return resolve();
        })
        .catch(err => {
          console.log('err', err);
          toastr.error('Error');
          return reject();
        });
    });
    return promise;
  };
}

export function getCourseName(courseId, courses) {
  let c = courses.filter(function(course) {
    return course.id == courseId;
  });
  if (c.length > 0) {
    return c[0].slug;
  }
}

export function getCourseObjById(courseId, courses) {
  let c = courses.filter(function(course) {
    return course.id == courseId;
  });
  if (c.length > 0) {
    return c[0];
  }
}

export function getCoursesObjsByIds(ids, courses) {
  return Object.keys(courses).reduce((memo, key) => {
    if (ids.includes(courses[key].id)) {
      memo.push(courses[key])
    }
    return memo
  }, [])
}

export function getObjectById(id, array) {
  let obj = array.filter(c => {
    return c.id == id;
  });
  if (obj[0]) {
    return obj[0];
  }
}

export function getCourseLocations(course) {
  let groups = _.groupBy(course.meetings, function(value) {
    return value.location + '#' + value.starttime + '#' + value.endtime + '#' + value.startdate + '#' + value.enddate;
  });

  let locations = _.map(groups, function(group) {
    return {
      location: group[0].location,
      startTime: group[0].starttime,
      endTime: group[0].endtime,
      startDate: group[0].startdate,
      endDate: group[0].enddate,
      days: _.pluck(group, 'day')
    };
  });
  return locations;
}

export function unique(origArr) {
  let newArr = [],
    origLen = origArr.length,
    found,
    x,
    y;
  for (x = 0; x < origLen; x++) {
    found = undefined;
    for (y = 0; y < newArr.length; y++) {
      if (origArr[x].id === newArr[y].id) {
        found = true;
        break;
      }
    }
    if (!found) {
      newArr.push(origArr[x]);
    }
  }
  return newArr;
}



// WEBPACK FOOTER //
// ./src/actions/commonActions.js